/**
 * Canonical GLS non-Prismic init `provider` values.
 * Mirrors `PROVIDER_NAME_LAUNCH` in casino-game-launch-service.
 */
const GLS_LAUNCH_PROVIDER = {
  IGT: 'IGT',
  LNW: 'LNW',
  DGC: 'DGC',
  EVOLUTION: 'EVOLUTION',
  EVERI: 'EVERI',
  HIGH5: 'HIGH5',
  ARISTOCRAT: 'ARISTOCRAT',
  SPINGAMING: 'SPINGAMING',
  SLINGO: 'SLINGO',
  EZUGI: 'EZUGI',
  NETENT: 'NETENT',
  PLAYTECH: 'PLAYTECH',
  PLAYTECH_POKER: 'PLAYTECH_POKER',
  PRAGMATIC: 'PRAGMATIC',
  AWAGER: 'AWAGER',
  FUSION: 'FUSION',
  WHITE_HAT: 'WHITE_HAT',
  GAMECODE: 'GAMECODE',
  AGS: 'AGS',
  FLUTTER_STUDIOS: 'FLUTTER_STUDIOS',
  GAMING_REALMS: 'GAMING_REALMS',
} as const;

/**
 * Prismic / aggregation aliases → GLS launch `provider`.
 * Mirrors `mapProviderToLaunch` in casino-game-launch-service (`init.helpers.ts`).
 * Generic provider renames align with `GenericProvider` in casino-game-client.
 */
const PRISMIC_ALIAS_TO_GLS_LAUNCH: Record<string, string> = {
  RGS: GLS_LAUNCH_PROVIDER.IGT,
  IGT: GLS_LAUNCH_PROVIDER.IGT,
  NETENT: GLS_LAUNCH_PROVIDER.EVOLUTION,
  EVOLUTION: GLS_LAUNCH_PROVIDER.EVOLUTION,
  EVERI: GLS_LAUNCH_PROVIDER.EVERI,
  NYX: GLS_LAUNCH_PROVIDER.LNW,
  HIGH5: GLS_LAUNCH_PROVIDER.HIGH5,
  DGC: GLS_LAUNCH_PROVIDER.DGC,
  ARISTOCRAT: GLS_LAUNCH_PROVIDER.ARISTOCRAT,
  SPINGAMING: GLS_LAUNCH_PROVIDER.SPINGAMING,
  SPIN: GLS_LAUNCH_PROVIDER.SPINGAMING,
  EZUGI: GLS_LAUNCH_PROVIDER.EZUGI,
  REALMS: GLS_LAUNCH_PROVIDER.SLINGO,
  SLINGO: GLS_LAUNCH_PROVIDER.SLINGO,
  PLAYTECH: GLS_LAUNCH_PROVIDER.PLAYTECH,
  PLAYTECH_POKER: GLS_LAUNCH_PROVIDER.PLAYTECH_POKER,
  PRAGMATIC: GLS_LAUNCH_PROVIDER.PRAGMATIC,
  AWAGER: GLS_LAUNCH_PROVIDER.AWAGER,
  FUSION: GLS_LAUNCH_PROVIDER.FUSION,
  WHITEHAT: GLS_LAUNCH_PROVIDER.WHITE_HAT,
  GAMECODE: GLS_LAUNCH_PROVIDER.GAMECODE,
  AGS: GLS_LAUNCH_PROVIDER.AGS,
  FLUTTERSTUDIOS: GLS_LAUNCH_PROVIDER.FLUTTER_STUDIOS,
  GAMINGREALMS: GLS_LAUNCH_PROVIDER.GAMING_REALMS,
};

const PROVIDER_TO_GLS_LAUNCH: Record<string, string> = {
  ...GLS_LAUNCH_PROVIDER,
  ...PRISMIC_ALIAS_TO_GLS_LAUNCH,
};

/** Canonical `provider` for GLS reconcile (non-Prismic init). */
export const normalizeGlsLaunchProvider = (provider: string): string => {
  const key = provider.trim().toUpperCase();
  if (!key) {
    return provider;
  }
  return PROVIDER_TO_GLS_LAUNCH[key] ?? key;
};
